import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AntdApp, ConfigProvider } from "antd";
import { AuthProvider, LanguageProvider, WebProvider } from "./context";
import { Router } from "./router";
import { vars } from "./assets";

const queryClient = new QueryClient();
function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: vars.colorPrimary,
          colorPrimaryActive: vars.colorPrimary,
          colorPrimaryHover: vars.colorPrimaryHover,
          colorPrimaryText: vars.colorBlackLight,
          colorPrimaryTextActive: vars.colorBlackLight,
          colorPrimaryTextHover: vars.colorBlackLight,
          colorIconHover: vars.colorPrimaryHover,
          colorLinkHover: vars.colorPrimaryHover,
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        <LanguageProvider>
          <AuthProvider>
            <WebProvider>
              <AntdApp>
                <Router />
              </AntdApp>
            </WebProvider>
          </AuthProvider>
        </LanguageProvider>
      </QueryClientProvider>
    </ConfigProvider>
  );
}

export default App;
